<template>
    <page-controls>
        <template v-slot:right>
            <vx-button @click.prevent="modalVisible = true" data-test="create-migration">
                New Migration <font-awesome-icon widthAuto :icon="faCirclePlus" size="lg" />
            </vx-button>
        </template>
    </page-controls>

    <team-migration-create-modal v-model:visible="modalVisible"></team-migration-create-modal>
</template>

<script setup>
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton } from '@voxie/frontend-components';
import { ref } from 'vue';
import PageControls from '~/components/general/PageControls.vue';
import TeamMigrationCreateModal from '~/components/kiosk/kiosk-migrations/form/TeamMigrationCreateModal.vue';

defineEmits(['reset']);

const modalVisible = ref(false);
</script>
